import config from 'common/config'
import Constants from 'common/constants'
import Http from 'common/http'
import {
  ChangePasswordRequestInterface,
  SigninRequestInterface,
  SigninResponseInterface,
  VerifyResetKeyRequestInterface,
  VerifyResetKeyResponseInterface
} from './interfaces'

const basePath = `${config.API_URL}/${Constants.API_URl_PREFIX}/auth`

const AuthService = {
  login: (
    email: string,
    password: string
  ): Promise<SigninResponseInterface> => {
    return Http.post<
      Omit<SigninRequestInterface, 'code'>,
      SigninResponseInterface
    >(`${basePath}/signin`, { email, password }, { credentials: 'omit' })
  },

  forgetPassword: (email: string): Promise<void> => {
    try {
      return Http.post<{ email: string }, void>(
        `${basePath}/forget-password`,
        { email },
        { credentials: 'omit' }
      )
    } catch (error) {
      return Promise.reject(error)
    }
  },

  changePassword: (key: string, password: string): Promise<void> => {
    return Http.post<ChangePasswordRequestInterface, void>(
      `${basePath}/change-password`,
      { key, password },
      { credentials: 'omit' }
    )
  },

  verifyResetKey: (key: string): Promise<VerifyResetKeyResponseInterface> => {
    return Http.post<
      VerifyResetKeyRequestInterface,
      VerifyResetKeyResponseInterface
    >(`${basePath}/verify-reset-key`, { key }, { credentials: 'omit' })
  }
}

export default AuthService
